
export class SetCompanyInfo {
    static readonly type = '[Company] Set Company Info';
    constructor(public payload: string) { }
}
